import { PublicKey } from "@solana/web3.js";
import { Check, Copy, RefreshCw } from "lucide-react";

interface WalletBalanceProps {
	publicKey: PublicKey;
	balance: number;
	copied: boolean;
	formatAddress: (address: string) => string;
	handleCopyAddress: () => Promise<void>;
	handleRefresh: () => void;
	isRefreshing: boolean;
}

export const WalletBalance: React.FC<WalletBalanceProps> = ({
	publicKey,
	balance,
	copied,
	formatAddress,
	handleCopyAddress,
	handleRefresh,
	isRefreshing,
}) => (
	<>
		<div className="bg-[#231F20] p-3 md:p-4 rounded-lg mb-4">
			<p className="text-[#918884] text-xs md:text-sm mb-1">Wallet Address:</p>
			<div className="flex items-center justify-between">
				<p className="text-[#36C47D] break-all font-mono text-xs md:text-sm">
					{formatAddress(publicKey.toString())}
				</p>
				<button
					onClick={handleCopyAddress}
					className="ml-2 p-2 hover:bg-[#373132] rounded-lg transition-colors duration-200 flex items-center gap-1"
					aria-label={copied ? "Address copied" : "Copy address"}
				>
					{copied ? (
						<>
							<Check size={16} className="text-[#36C47D]" />
							<span className="text-[#36C47D] text-xs">Copied!</span>
						</>
					) : (
						<>
							<Copy size={16} className="text-[#918884]" />
							<span className="text-[#918884] text-xs">Copy</span>
						</>
					)}
				</button>
			</div>
		</div>

		<div className="bg-[#231F20] p-3 md:p-4 rounded-lg mb-4">
			<div className="flex items-center justify-between">
				<p className="text-[#FFF1E9] text-sm md:text-base">SOL Balance</p>
				<div className="flex items-center">
					<p className="text-[#36C47D] font-bold text-lg md:text-xl">
						{balance.toFixed(4)} SOL
					</p>
					<button
						onClick={handleRefresh}
						disabled={isRefreshing}
						className="ml-2 p-1 hover:bg-[#373132] rounded-full transition-colors disabled:opacity-50"
						aria-label="Refresh balance"
					>
						<RefreshCw
							size={16}
							className={`text-[#918884] ${isRefreshing ? "animate-spin" : ""}`}
						/>
					</button>
				</div>
			</div>
		</div>
	</>
);
